/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { diagnosisreference } from '../../ehr/subs/diagnosisreference';

export class medicalservicereference extends IceEntity {
  medical_service_reference_key: string = "";
  medical_service_key: string = "";
  sub_type: number = 0;
  encounter_progress_notes_key: string = "";

  DIAGREFS: diagnosisreference[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "MEDICAL_SERVICE_REFERENCE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DIAGREFS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DIAGREFS") return "DIAGNOSIS_REFERENCE";

    return null;
  }
}
